// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-area {
    background: #111111;
    height: 100vh;
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card__progress {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 6px;
    z-index: 5;
}

.progress-dot {
    width: 28px;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.progress-dot.active {
    background-color: rgba(255, 255, 255, 0.4);
}

.card {
    width: 375px;
    height: 667px;
    border-radius: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px;
}

.card-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;        /* ✅ igual que background-size: cover */
    object-position: center;  /* ✅ igual que background-position: center */
    border-radius: 10px;
}

.arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    border-radius: 50%;
    padding: 8px;
    cursor: pointer;
    z-index: 3;
}

.arrow:hover {
    background: rgba(0, 0, 0, 0.8);
}

.arrow--left {
    left: 12px;
}
.arrow--right {
    right: 12px;
}

.photo {
    width: 100%;
    height: 230px;
    object-fit: cover;
    border-radius: 10px;
}

.card__info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 0 50px 20px;
    box-sizing: border-box;
    color: white;
    border-radius: 10px;
    background: linear-gradient(to top, rgba(0, 0, 0, 100), 90%,transparent); /* 🎯 gradiente difuminado */
    backdrop-filter: blur(0.5px); /* opcional: desenfoque si usas fondo translúcido */
}

.distance {
    font-size: 0.8rem;
    margin-top: 4px;
}

.card__actions {
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 32px;
    z-index: 2;
}

.btn {
    background: white;
    border: none;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    cursor: pointer;
}

.btn--no:hover svg {
    color: #ff1f1f;
}
.btn--yes:hover svg {
    color: #00b14f;
}

.btn:hover {
    transform: scale(1.1);
}

.top_track_photo{
    border-radius: 4px;
}

.top__track__header {
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 6px;
}

.top__track {
    display: flex;
    gap: 16px;
}

.top__track__title {
    font-weight: bold;
}

.card__info--title h2 {
    margin: 10px 0 0 0;
    text-align: left;
    color: #d9d9d9;
}

.card__info--title p {
    margin: 10px 0 0 0;
    font-size: 16px;
    text-align: left;
    color: #d9d9d9;
}

.top__track_info {
    display: flex;
    align-items: center;
}

.bio {
    font-weight: bold;
}

.favorite__artists {
    font-weight: bold;
}

.artist-row {
    display: flex;
    gap: 6px;
    align-items: center;
}
.artist-row img {
    height: 74px;
    border-radius: 4px;
}

.error-card {
    display: flex;
    align-items: center;
    text-align: center;
}

.error-card h1 {
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/card_area.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB,SAAS,uCAAuC;IACjE,uBAAuB,GAAG,4CAA4C;IACtE,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,wEAAwE,EAAE,4BAA4B;IACtG,4BAA4B,EAAE,mDAAmD;AACrF;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".card-area {\n    background: #111111;\n    height: 100vh;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.card__progress {\n    position: absolute;\n    top: 12px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 6px;\n    z-index: 5;\n}\n\n.progress-dot {\n    width: 28px;\n    height: 4px;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    transition: background-color 0.3s ease;\n}\n\n.progress-dot.active {\n    background-color: rgba(255, 255, 255, 0.4);\n}\n\n.card {\n    width: 375px;\n    height: 667px;\n    border-radius: 10px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 24px;\n}\n\n.card-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;        /* ✅ igual que background-size: cover */\n    object-position: center;  /* ✅ igual que background-position: center */\n    border-radius: 10px;\n}\n\n.arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    border-radius: 50%;\n    padding: 8px;\n    cursor: pointer;\n    z-index: 3;\n}\n\n.arrow:hover {\n    background: rgba(0, 0, 0, 0.8);\n}\n\n.arrow--left {\n    left: 12px;\n}\n.arrow--right {\n    right: 12px;\n}\n\n.photo {\n    width: 100%;\n    height: 230px;\n    object-fit: cover;\n    border-radius: 10px;\n}\n\n.card__info {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 0 0 50px 20px;\n    box-sizing: border-box;\n    color: white;\n    border-radius: 10px;\n    background: linear-gradient(to top, rgba(0, 0, 0, 100), 90%,transparent); /* 🎯 gradiente difuminado */\n    backdrop-filter: blur(0.5px); /* opcional: desenfoque si usas fondo translúcido */\n}\n\n.distance {\n    font-size: 0.8rem;\n    margin-top: 4px;\n}\n\n.card__actions {\n    position: absolute;\n    bottom: -25px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 32px;\n    z-index: 2;\n}\n\n.btn {\n    background: white;\n    border: none;\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.2);\n    cursor: pointer;\n}\n\n.btn--no:hover svg {\n    color: #ff1f1f;\n}\n.btn--yes:hover svg {\n    color: #00b14f;\n}\n\n.btn:hover {\n    transform: scale(1.1);\n}\n\n.top_track_photo{\n    border-radius: 4px;\n}\n\n.top__track__header {\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.top__track {\n    display: flex;\n    gap: 16px;\n}\n\n.top__track__title {\n    font-weight: bold;\n}\n\n.card__info--title h2 {\n    margin: 10px 0 0 0;\n    text-align: left;\n    color: #d9d9d9;\n}\n\n.card__info--title p {\n    margin: 10px 0 0 0;\n    font-size: 16px;\n    text-align: left;\n    color: #d9d9d9;\n}\n\n.top__track_info {\n    display: flex;\n    align-items: center;\n}\n\n.bio {\n    font-weight: bold;\n}\n\n.favorite__artists {\n    font-weight: bold;\n}\n\n.artist-row {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n.artist-row img {\n    height: 74px;\n    border-radius: 4px;\n}\n\n.error-card {\n    display: flex;\n    align-items: center;\n    text-align: center;\n}\n\n.error-card h1 {\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
